<div class="panel-background">
  <div class="no-print">
    <breadcrumb-actions-timepicker
      [breadCrumbValues]="breadCrumbValues"
      [testInfoValue]="testInfoValue"
      [timePickerValue]="timePickerValue"
    ></breadcrumb-actions-timepicker>
  </div>
  <div class="no-print filter-header">
    <div class="sticky-bar">
      <div>
        <!-- <div> -->
        <button
          mat-button
          color="primary"
          (click)="slaThreshold()"
          class="font-600"
          *ngIf="slaThresholdBoolean"
        >
          <i class="mdi mdi-chart-areaspline icon"></i>
          Remove SLA
        </button>
        <button
          mat-button
          color="primary"
          (click)="slaThreshold()"
          class="font-600"
          *ngIf="!slaThresholdBoolean"
        >
          <i class="mdi mdi-chart-areaspline icon"></i>
          Display SLA
        </button>
        <!-- <span *ngIf="slaThresholdBoolean"> Remove SLA</span
          ><span *ngIf="!slaThresholdBoolean"> Display SLA</span> -->
        <!-- </div> -->
        <!-- <div> -->
        <button
          useExistingCss="true"
          openNewTab="true"
          printSectionId="print-section"
          ngxPrint
          mat-button
          color="primary"
          class="font-600"
        >
          <i class="mdi mdi-printer icon"></i>
          Print
        </button>
      </div>
    </div>
  </div>
  <div class="panel">
    <div class="report-panel" *ngIf="!isLoading && scheduleId && runId" id="print-section">
      <div
        class="scroll vi-primary vi-hue-1 print-content no-print-flexbox twamp-content internal"
        #pdfPage
        *ngIf="!loading"
      >
        <div class="page">
          <div class="page-break"></div>

          <div class="report-header">
            <img src="{{ logoUrl }}" class="truespeed-logo" />
            <h2 class="truespeed-title">Performance Monitoring Report</h2>
          </div>

          <hr />
          <div style="align-items: center !important">
            <div class="page" style="width: 95% !important">
              <div style="margin-top: 10px">
                <div class="header-style">
                  <div class="header-class">Name</div>
                  <div class="value-font">
                    {{ reportName }}
                  </div>
                </div>
              </div>
              <div style="margin-top: 10px">
                <div class="header-style">
                  <div class="header-class">Type</div>
                  <div class="value-font">{{ testTypeName }}</div>
                </div>
                <div class="header-style">
                  <div class="header-class">Beginning</div>
                  <div class="value-font">
                    {{ reportStart }}
                  </div>
                </div>
                <div class="header-style">
                  <div class="header-class">Ending</div>
                  <div class="value-font">{{ reportEnd }}</div>
                </div>
                <div class="header-style">
                  <div class="header-class">PM Sample Interval</div>
                  <div class="value-font">{{ pmInterval }}</div>
                </div>
              </div>
              <div style="margin-top: 10px">
                <div class="header-style">
                  <div class="header-class">Flows in report</div>
                  <div class="value-font">{{ reportFlows }}</div>
                </div>
                <div class="header-style">
                  <div class="header-class">Test Point</div>
                  <div class="value-font">{{ testPoint }}</div>
                </div>
              </div>
              <div
                *ngIf="
                  (requestInfo?.customerInfo?.name ||
                    requestInfo?.customerInfo?.contact ||
                    requestInfo?.customerInfo?.phone ||
                    requestInfo?.customerInfo?.email)"
              >
                <div class="reports-customer-info">
                  <div class="info-title">Customer</div>
                  <div class="info-container">
                    <div class="details-sec" *ngIf="requestInfo?.customerInfo?.name">
                      <div class="sec-header">Name</div>
                      <div class="sec-value">{{ requestInfo.customerInfo.name }}</div>
                    </div>
                    <div class="details-sec" *ngIf="requestInfo?.customerInfo?.contact">
                      <div class="sec-header">Contact</div>
                      <div class="sec-value">{{ requestInfo.customerInfo.contact }}</div>
                    </div>
                    <div class="details-sec" *ngIf="requestInfo?.customerInfo?.email">
                      <div class="sec-header">Email</div>
                      <div class="sec-value">{{ requestInfo.customerInfo.email }}</div>
                    </div>
                    <div class="details-sec" *ngIf="requestInfo?.customerInfo?.phone">
                      <div class="sec-header">Phone</div>
                      <div class="sec-value">{{ requestInfo.customerInfo.phone }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="requestInfo?.technicianName || requestInfo?.technicianId"
      >
        <div class="reports-customer-info">
          <div class="info-title">Technician</div>
          <div class="info-container-custom">
            <div
          class="details-sec"
          *ngIf="requestInfo?.technicianName"
        >
          <div class="sec-header">Name</div>
          <div class="sec-value">
            {{ requestInfo.technicianName }}
          </div>
        </div>
        <div class="details-sec"
          *ngIf="requestInfo?.technicianId"
        >
          <div class="sec-header">ID</div>
          <div class="sec-value">
            {{ requestInfo.technicianId }}
          </div>
        </div>
        <div style="margin-top: 30px" *ngIf="requestInfo && requestInfo.comments">
          <div class="header-style">
            <div class="header-class">Comments</div>
            <div class="value-font">
              {{ requestInfo.comments }}
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>

            </div>

            <div style="margin-top: 10px" *ngFor="let flow of chartDataArray">
              <div class="flowName">{{ flow.flowName }}</div>
              <!-- Loop through each chart configuration for the current flowName -->
              <div class="page" style="width: 95% !important">
                <div class="margin-top: 25px" *ngFor="let config of flow.chartData; let i = index">
                  <div class="page" style="width: 93% !important">
                    <div class="chart-container">
                      <h5>{{ flow.titles[i] }}</h5>
                      <h6>Click labels in legend to toggle display of series.</h6>
                      <nrwl-single-value-chart
                        [dataSource]="flow.chartData[i]"
                        [options]="getSingleValueChartOptions(i)"
                        [conversionUnits]="getConversionUnit(i)"
                        [yAxisTickLabelFormat]="getDisplayUnit(i)"
                        [granularity]="granularityInterval"
                        [kpiUnit]="getKpiUnit(i)"
                        [loader]="false"
                        [chartZoomWithTime]="false"
                      >
                      </nrwl-single-value-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page" *ngIf="reportmessage && reportmessage?.length !== 0">
          <div class="page-break"></div>

          <mat-toolbar class="diagnosis-head border">
            <div class="mat-toolbar-tools">
              <h2 class="mat-flex">Report Message</h2>
            </div>
          </mat-toolbar>

          <mat-card class="border" fxLayout="column" fxLayoutGap="16px">
            <div fxLayout="row">
              <span>{{ reportmessage }}</span>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="twamp-content">
  <div class="loader-content" *ngIf="loading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">{{ statusLabel }}</div>
      <mat-progress-bar mode="determinate" [value]="progressPercentage"></mat-progress-bar>
      <div class="progress-label">
        {{ rptSamplesReceived }} / {{ rptSamplesNeeded }} samples ({{
          progressPercentage.toFixed(2)
        }}%)
      </div>
    </div>
  </div>
</div>
